export const processMediaTags = async (htmlString: string): Promise<string> => {
  const mediaTagRegex = /<(video|audio)[^>]*\s+src=["']([^"']+)["'][^>]*>/gi;

  let iterate = 1;
  let match: RegExpExecArray | null;
  const promises: Promise<void>[] = [];
  const replacements: { match: string; replacement: string }[] = [];

  while ((match = mediaTagRegex.exec(htmlString)) !== null) {
    const [fullMatch, tag, url] = match;

    const promise = fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const myFile = new File([blob], `media-${iterate}`, {
          type: tag.toLowerCase() === 'video' ? 'video/mp4' : 'audio/mp3'
        });
        const blobUrl = URL.createObjectURL(myFile);

        let newTag = fullMatch
          // remove autoplay (autoplay, autoplay="true", autoplay='true')
          .replace(/\sautoplay(=(["'])?true\2)?/gi, '');

        // add controls if missing (matches `controls` as a standalone attribute)
        const hasControls = /\scontrols(?=[\s=>/])/i.test(newTag);
        if (!hasControls) {
          // insert right after the tag name: <video controls ...>
          newTag = newTag.replace(/^<(video|audio)/i, '<$1 controls');
        }

        replacements.push({
          match: fullMatch,
          replacement: newTag.replace(url, blobUrl)
        });
      });

    iterate++;
    promises.push(promise);
  }

  await Promise.allSettled(promises);

  let processedHtml = htmlString;
  replacements.forEach(({ match, replacement }) => {
    processedHtml = processedHtml.replace(match, replacement);
  });

  return processedHtml;
};
